import { ITEMS_AHEAD, ITEMS_BEHIND } from './constants'

export const wrapIndex = (index: number, length: number) =>
  ((index % length) + length) % length

/** Arrow keys must not steal focus while typing in the reject note (etc.). */
export const isEditableKeyboardTarget = (target: EventTarget | null) => {
  if (!(target instanceof HTMLElement)) {
    return false
  }

  return Boolean(
    target.closest('input, textarea, select, [contenteditable="true"]')
  )
}

export const buildVisibleWindow = <T>(items: T[], currentIndex: number) => {
  if (items.length === 0) {
    return []
  }

  const offsets = [
    0,
    ...Array.from({ length: ITEMS_BEHIND }, (_, i) => -(i + 1)),
    ...Array.from({ length: ITEMS_AHEAD }, (_, i) => i + 1)
  ]

  const seen = new Set<number>()
  const visible: { item: T; offset: number }[] = []

  for (const offset of offsets) {
    const index = wrapIndex(currentIndex + offset, items.length)

    if (seen.has(index)) {
      continue
    }

    seen.add(index)
    visible.push({ item: items[index], offset })
  }

  return visible
}
